import YtScreenSearch from './screen-search'

export default {
  install: (Vue) => {
    Vue.component('yt-screen-search', YtScreenSearch)
  }
}